import * as React from 'react';
import * as styles from './MapPin.css';
import classNames from 'classnames';

export interface IMapPinProps {
  theme: 'default' | 'plus';
}

export function MapPin(props: IMapPinProps) {
  const { theme } = props;
  const themeStyle = theme === 'default' ? styles['pin-default'] : styles['pin-plus'];

  return <span className={classNames(styles['pin'], themeStyle)} />;
}
